import React, { useState, useEffect, useCallback } from 'react'
import Select from 'react-select'
import SeguridadesLogic from '../../functions/logic/Seguridades'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Spiner from '../../components/General/Spiner'
import { useSnackbar } from 'notistack'

const TablerosLinks = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [userOptions, setUsers] = useState([])
  const [roleOptions, setRoles] = useState([])
  const [spiner, setSpiner] = useState(false)
  const [userType, setUserType] = useState('I')

  // Variables adicionales para almacenar roles y usuarios con estado S/N
  const [listRoles, setListRoles] = useState([])
  const [listUsuario, setListUsuario] = useState([])

  const getGroupUser = useCallback(async (page, perPage) => {
    setSpiner(true)
    const resp = await SeguridadesLogic.usuariosLinkLogic(page, perPage, userType)
    if (resp.success) {
      const formattedUsers = resp.data
        .filter(users => users.Usuarios && users.Usuarios.trim() !== '')
        .map(users => ({
          value: users.id,
          label: users.Usuarios
        }))
      setUsers(formattedUsers)
    }

    const respRoles = await SeguridadesLogic.rolesLogic(page, perPage, '')
    if (respRoles.success) {
      const formattedRoles = respRoles.data
        .filter(roles => roles.Codigo && roles.Codigo.trim() !== '')
        .map(roles => ({
          value: roles.Codigo,
          label: roles.Nombre
        }))
      setRoles(formattedRoles)
    }

    const tablRolUserResp = await ConfiguracionLogic.tabRoleUserLogic(localStorage.getItem('dahboardOnlInkId'));
    if (tablRolUserResp.success) {
      const initialSelectedRoles = (tablRolUserResp.data.listRoles || []).map(role => ({
        value: role.codigoRol,
        label: role.nombreRol,
      }));

      const initialSelectedUsers = (tablRolUserResp.data.listUsuario || []).map(user => ({
        value: user.secuenciaUsuario,
        label: user.nombreUsuario,
      }));

      setSelectedRoles(initialSelectedRoles);
      setSelectedUsers(initialSelectedUsers);

      setListRoles(initialSelectedRoles.map(role => ({ ...role, estado: 'S' })));
      setListUsuario(initialSelectedUsers.map(user => ({ ...user, estado: 'S' })));
    }
    setSpiner(false)
  }, [])

  useEffect(() => {
    getGroupUser(1, 500)
  }, [getGroupUser])

  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])

  // Manejar cambios en las selecciones de roles
  const handleRolesChange = (selectedOption) => {
    if (selectedOption && !selectedRoles.includes(selectedOption)) {
      setSelectedRoles([...selectedRoles, selectedOption])

      // Agregar rol a la lista con estado 'S'
      setListRoles((prevRoles) => [
        ...prevRoles,
        { codigoRol: selectedOption.value, nombreRol: selectedOption.label, estado: 'S' },
      ])
    }
  }

  const handleUsersChange = (selectedOption) => {
    if (selectedOption && !selectedUsers.includes(selectedOption)) {
      setSelectedUsers([...selectedUsers, selectedOption])

      // Agregar usuario a la lista con estado 'S'
      setListUsuario((prevUsuarios) => [
        ...prevUsuarios,
        { secuenciaUsuario: selectedOption.value, nombreUsuario: selectedOption.label, estado: 'S' },
      ])
    }
  }

  // Funciones para eliminar roles y usuarios
  const removeRole = (index) => {
    const removedRole = selectedRoles[index]
    setSelectedRoles(selectedRoles.filter((_, i) => i !== index))

    // Cambiar estado del rol eliminado a 'N' en la lista
    setListRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.value === removedRole.value ? { ...role, estado: 'N' } : role
      )
    )
  }

  const removeUser = (index) => {
    const removedUser = selectedUsers[index]
    setSelectedUsers(selectedUsers.filter((_, i) => i !== index))

    setListUsuario((prevUsuarios) =>
      prevUsuarios.map((usuario) =>
        usuario.value === removedUser.value ? { ...usuario, estado: 'N' } : usuario
      )
    )
  }

  const saveRolUser = async (event) => {
    event.preventDefault()
    setSpiner(true)
    const initialSelectedRoles = (listRoles || []).map(role => ({
      codigoRol: role.codigoRol || role.value,
      nombreRol: role.nombreRol || role.label,
      estado: role.estado
    }))

    const initialSelectedUsers = (listUsuario || []).map(user => ({
      secuenciaUsuario: user.secuenciaUsuario || user.value,
      nombreUsuario: user.nombreUsuario || user.label,
      estado: user.estado
    }))
    const resp = await ConfiguracionLogic.saveTabRoleUserLogic(
      localStorage.getItem('dahboardOnlInkId'),
      localStorage.getItem('nombreOnlInkId'),
      initialSelectedRoles,
      initialSelectedUsers
    )
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    })
    setSpiner(false)
    if (resp.success) {
      getGroupUser(1, 500)
    }
  }

  const onReturn = () => {
    localStorage.removeItem('dahboardOnlInkId')
    localStorage.removeItem('nombreOnlInkId')
    window.location = global.TABLERO
  }

  const handleUserTypeChange = async (type) => {
    setSpiner(true)
    setUserType(type)
    const resp = await SeguridadesLogic.usuariosLinkLogic(1, 500, type)
    if (resp.success) {
      const formattedUsers = resp.data
        .filter(users => users.Usuarios && users.Usuarios.trim() !== '')
        .map(users => ({
          value: users.id,
          label: users.Usuarios
        }))
      setUsers(formattedUsers)
    }
    setSpiner(false)

  }

  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <b>{localStorage.getItem('nombreOnlInkId')}</b>
                </div>

                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card p-3">
                          <div className="">
                            <div className="col-auto">
                              <div className="d-flex justify-content-center">
                                <div className="form-check form-check-inline">
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      checked={userType === "I"}
                                      name="userType"
                                      id="internalUsers"
                                      onClick={() => handleUserTypeChange('I')}
                                    />
                                    <label className="form-check-label" htmlFor="internalUsers">Usuarios Internos</label>
                                  </div>
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    checked={userType === "E"}
                                    name="userType"
                                    id="externalUsers"
                                    onClick={() => handleUserTypeChange('E')}
                                  />
                                  <label className="form-check-label" htmlFor="externalUsers">Usuarios Externos</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Sección de Roles */}
                      <div className="col-md-6">
                        <div className="card p-3">
                          <label>Rol</label>
                          <p>Seleccione rol que desea asociar a este tablero</p>
                          <Select
                            options={roleOptions}
                            placeholder="Seleccionar"
                            onChange={handleRolesChange}
                            isClearable
                          />
                          <div className="mt-3">
                            {selectedRoles.map((role, index) => (
                              <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                <span>{role.label}</span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeRole(index)}
                                  style={{ fontSize: '0.60rem' }}
                                >
                                  <i className="fas fa-trash-alt" style={{ fontSize: '0.60rem' }}></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Sección de Usuarios */}
                      <div className="col-md-6">
                        <div className="card p-3">
                          <label>Usuario</label>
                          <p>Seleccione usuario que desea asociar a este tablero</p>
                          <Select
                            options={userOptions}
                            placeholder="Seleccionar"
                            onChange={handleUsersChange}
                            isClearable
                          />
                          <div className="mt-3" >
                            {selectedUsers.map((user, index) => (
                              <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                <span>{user.label}</span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => removeUser(index)}
                                  style={{ fontSize: '0.60rem' }}
                                >
                                  <i className="fas fa-trash-alt" style={{ fontSize: '0.60rem' }}></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row justify-content-end mt-3">
                      <button type="submit" onClick={saveRolUser} className="btn btn-primary mr-2">Guardar</button>
                      <button type="button" onClick={onReturn} className="btn btn-default">Cancelar</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TablerosLinks
